
export default {
  name: 'MegasredaContentRecommendationsCreate',
  props: {
    recommendation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      streamsVisibleCount: 8,
      filterMenu: [],
      isShowAllMenu: false,
      localRecommendation: this._.cloneDeep(this.recommendation),
    }
  },
  methods: {
    open() {
      this.$refs.recommendedPopUp.open()
    },
    contentChange(content) {
      this.localRecommendation.text = content
    },

    async publishRecommendation() {
      try {
        await this.$axios.$put(
          '/recommendations/update',
          this.localRecommendation
        )
        await this.$axios.$put(
          `/recommendations/publish/${this.recommendation._id}`
        )
        this.$refs.recommendedPopUp.close()
        this.$eventBus.$emit('publish-recommendation')
        this.$emit('publish')
      } catch (error) {
        console.log(error)
      }
    },
    closeRecommendationPopUp() {
      this.$refs.recommendedPopUp.close()
    },
  },
}
